export default "__VITE_ASSET__$td3NFn0__"